/**
 * Вкладки дашборда склада — ОДНА карта: порядок в панели, подпись и источники
 * данных (какие запросы грузит вкладка; `enabled` запроса — «его источник есть
 * у открытой вкладки»). Новая вкладка добавляется строкой здесь и веткой в
 * `WarehouseDashboardPage`.
 *
 * Активная вкладка живёт в URL (`?tab=`): ссылку можно переслать, и она же
 * заменяет старый адрес `/warehouse-turnover` (редирект в `routes.tsx`).
 */

/** Холодные запросы (1С живьём, кеша на бэкенде нет): возврат на вкладку не
 *  повод дёргать 1С заново, обновление — кнопкой, рядом время среза. Одно
 *  значение на все запросы дашборда, включая позиции склада «Остатков». */
export const DASHBOARD_STALE_MS = 5 * 60_000;

export const DASHBOARD_TABS = [
  // «Обзор» — сводка для руководителя: четыре запроса параллельно, те же
  // ключи react-query, что у остальных вкладок (кеш общий).
  {
    key: "overview",
    title: "Обзор",
    sources: ["summary", "turnover", "operations", "shipments"],
  },
  { key: "stock", title: "Остатки", sources: ["summary"] },
  // Сверху — «Просрочка и риск» (свой запрос `/expiry-risk`, порог в ключе).
  { key: "shelf-life", title: "Сроки годности", sources: ["summary", "expiry_risk"] },
  { key: "turnover", title: "Оборачиваемость", sources: ["turnover"] },
  { key: "operations", title: "Операции", sources: ["operations"] },
] as const;

export type DashboardTab = (typeof DASHBOARD_TABS)[number]["key"];
export type DashboardTabSource = (typeof DASHBOARD_TABS)[number]["sources"][number];

export const DEFAULT_TAB: DashboardTab = "overview";

/** Параметр URL, в котором лежит вкладка. */
export const TAB_PARAM = "tab";

/** Вкладка из `?tab=`. Неизвестное или пустое значение — вкладка по умолчанию:
 *  это навигация (старая закладка, опечатка в ссылке), а не данные, и падать
 *  на ней незачем — экран с вкладками всё равно видно. */
export function tabFromParam(value: string | null): DashboardTab {
  return DASHBOARD_TABS.find((t) => t.key === value)?.key ?? DEFAULT_TAB;
}

export function tabSources(tab: DashboardTab): readonly DashboardTabSource[] {
  // `tab` — ключ из той же карты, запись есть всегда.
  return DASHBOARD_TABS.find((t) => t.key === tab)!.sources;
}

export function dashboardTabPath(tab: DashboardTab): string {
  return `/warehouse-dashboard?${TAB_PARAM}=${tab}`;
}
